export default "__VITE_ASSET__16ebe04a__"